import axios from "axios";
export const baseConfig = axios.create({
    // demo url
    // baseURL: "https://guester.talrop.works/api/v1/",
    // live url
    baseURL: "https://www.admin.theguester.com/api/v1/",
    // local url
    // baseURL: "http://192.168.0.180:7000/",
});
